import * as React from 'react'
import { Tag, Intent } from '@blueprintjs/core'
import { toTitleCase } from '../../../../utils'

export type ValidOrderStatus = 'open' | 'archived' | 'cancelled'

export interface OrderStatusTagProps {
  value: ValidOrderStatus
}

const highlightMap = {
  open: Intent.PRIMARY,
  cancelled: Intent.DANGER,
  archived: Intent.NONE
}

const OrderStatusTag: React.FC<OrderStatusTagProps> = props => {
  return (
    <Tag round minimal intent={highlightMap[props.value]}>
      {toTitleCase(props.value)}
    </Tag>
  )
}
export default OrderStatusTag
